import { Dialog, DialogProps } from "@mui/material";

import AppModalContent from "@/common/components/Modals/AppModalContent";
import { ViewVariant } from "@/common/ts/layout";

import RepairSparePartView, { RepairSparePartViewProps } from "./RepairSparePartView";

export interface OwnProps {
  viewProps: RepairSparePartViewProps;
}

type Props = OwnProps & DialogProps;

export default function RepairSparePartViewModal({ viewProps, ...dialogProps }: Props) {
  return (
    <Dialog fullWidth maxWidth='lg' {...dialogProps}>
      <AppModalContent>
        <RepairSparePartView
          onDeleted={() => {
            dialogProps.onClose && dialogProps.onClose({}, "escapeKeyDown");
          }}
          {...viewProps}
          displayProps={{
            viewVariant: ViewVariant.Tab, // TODO: must be Modal
            ...viewProps?.displayProps,
          }}
        />
      </AppModalContent>
    </Dialog>
  );
}
